import { YA_METRIC_ID } from '~/constants/config';
import { useUserStore } from '~/features/user/store';
import type { YandexMetrikData } from '~/types/analytics/yandexMetrik';
import { sendYandexMetrika } from '~/utils/analytics';
import type { NuxtApp } from '#app';

export default defineNuxtPlugin({
  name: 'data-layer',
  async setup(nuxtApp) {
    const userStore = useUserStore();
    const log = (nuxtApp as NuxtApp).$logger.withScope('🍰 data-layer-plugin');

    watch(
      () => userStore.userData?.integer_id,
      (userId) => {
        if (!userId) return;
        log('add userId', userId);
        window?.ym(YA_METRIC_ID, 'params', { user_id: String(userId) });
      },
    );

    nuxtApp.provide('sendYandexMetrika', (analyticsParams: YandexMetrikData) => {
      const route = useRoute();

      // для превью не отправляем аналитику
      if (route.name === 'preview') return;

      log('send yandex metrika', analyticsParams);
      sendYandexMetrika(analyticsParams);
    });
  },
});
